import React from 'react';
import PropTypes from 'prop-types';
import YamlCodeEditor from 'app/components/YamlCodeEditor';
import stringifyEditorYaml from 'app/components/YamlCodeEditor/stringifyEditorYaml';

const STATIC_PROPS = {
  readOnly: true,
};

export default function PipelineTransformationsYamlEditor({ name, value }) {
  const props = {
    ...STATIC_PROPS,
    name,
    value: stringifyEditorYaml(value),
  };
  return <YamlCodeEditor {...props} />;
}

PipelineTransformationsYamlEditor.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object.isRequired,
};
